<template lang="pug">
  .component.component-backoffice-note(v-if="item")
    .card( v-if="$is('listing')")
      .inner-content
        .row
          .column.shrink
            dropdown(:icon="'fa fa-ellipsis-v fa-2x action'", :position="'top'")
              InterventionRequestButtons(:item="item")
          .column
            .field-value IR{{item.id}}
            .label Priority
            .field-value {{priority}}
          .column.shrink
            .label Status
            .field-value {{item.status}}
            .label Type
            .field-value {{item.type}}
            template(v-if="item.reservation" )
              div
                .label Reservation &nbsp;
                  router-link(:to="{name:'reservation', params:{id:item.reservation.id}}")
                    span R{{item.reservation.id}}
                .field-value {{item.reservation.status}}

          .column
              template(v-if="!item.driver" )
                h5 Not assigned
              BackofficeDriver(v-else, :item="item.driver", type="oneLook" )
              template(v-if="item.start" )
                .label Started at
                .field-value {{$dateFormat(item.start, $toMomentFormat(configuration.locale.locale_datetime_format.value))}}
              template(v-if="item.end" )
                .label Completed at
                .field-value(v-if="item.end" ) {{$dateFormat(item.end, $toMomentFormat(configuration.locale.locale_datetime_format.value))}}
          .column.text-center
            vehicle(:item="item.vehicle", type="oneLook")
            vehicle(:item="item.vehicle", type="maintenance")
          .column
            .label Created
            .field-value {{$dateFormat(item.created_at, $toMomentFormat(configuration.locale.locale_datetime_format.value))}}
            .label Start
            .field-value {{$dateFormat(item.start_at, $toMomentFormat(configuration.locale.locale_datetime_format.value))}}
            .label Expiry
            .field-value {{$dateFormat(item.expiry, $toMomentFormat(configuration.locale.locale_datetime_format.value))}}
          .column.shrink.text-right
            span.fa.fa-2x(v-if="item.linked_requests.length", @click="showSub = !showSub", :class=" {'fa-chevron-up' : showSub, 'fa-chevron-down':!showSub}", style="cursor: pointer")
        template(v-for="request in item.linked_requests", v-if="showSub" )
          hr
          InterventionRequest(:item="request", type="detail-listing" )
    .card( v-if="$is('detail-listing')")
      .inner-content
        .row
          .column.shrink
            dropdown(:icon="'fa fa-ellipsis-v fa-2x action'", :position="'top'")
              InterventionRequestButtons(:item="item")
          .column
            .field-value IR{{item.id}}
            .label Priority
            .field-value {{priority}}
          .column.shrink
            .label Status
            .field-value {{item.status}}
            .label Type
            .field-value {{item.type}}
            template(v-if="item.reservation" )
              div
                .label Reservation &nbsp;
                  router-link(:to="{name:'reservation', params:{id:item.reservation.id}}")
                    span R{{item.reservation.id}}
                .field-value {{item.reservation.status}}

          .column
            template(v-if="!item.driver" )
              h5 Not assigned
            BackofficeDriver(v-else, :item="item.driver", type="oneLook" )
            template(v-if="item.start" )
              .label Started at
              .field-value {{$dateFormat(item.start, $toMomentFormat(configuration.locale.locale_datetime_format.value))}}
            template(v-if="item.end" )
              .label Completed at
              .field-value(v-if="item.end" ) {{$dateFormat(item.end, $toMomentFormat(configuration.locale.locale_datetime_format.value))}}
          .column
            .label Created
            .field-value {{$dateFormat(item.created_at, $toMomentFormat(configuration.locale.locale_datetime_format.value))}}
            .label Start
            .field-value {{$dateFormat(item.start_at, $toMomentFormat(configuration.locale.locale_datetime_format.value))}}
            .label Expiry
            .field-value {{$dateFormat(item.expiry, $toMomentFormat(configuration.locale.locale_datetime_format.value))}}
          .column.shrink.text-right
            span.fa.fa-2x(v-if="item.linked_requests.length", @click="showSub = !showSub", :class=" {'fa-chevron-up' : showSub, 'fa-chevron-down':!showSub}", style="cursor: pointer")
        template(v-for="request in item.linked_requests", v-if="showSub" )
          hr
          InterventionRequest(:item="request", type="detail-listing" )


</template>
<script type="text/babel">
import CardN from 'components/structure/CardN'
import Dropdown from '../structure/foundation/Dropdown'
import VehicleCostButtons from '../structure/ui/actions/VehicleCostButtons'
import VehicleNoteButtons from '../structure/ui/actions/VehicleNoteButtons'
import {mapState} from 'vuex'
import Vehicle from "./Vehicle.vue";
import BackofficeDriver from "./Driver.vue";
import InterventionRequestButtons from "../structure/ui/actions/InterventionRequestButtons.vue";
import {EventBus} from "../../eventBus";

export default {
  name: "InterventionRequest",
  components: {
    InterventionRequestButtons,
    BackofficeDriver,
    Vehicle,
    VehicleNoteButtons,
    VehicleCostButtons,
    Dropdown,
    CardN,
  },
  data() {
    return {
      showSub: false
    }
  },
  created() {
  },
  methods: {
    close() {
      EventBus.$emit("close-modal")
    }
  },
  computed: {
    ...mapState({
      configuration: state => state.configuration,
    }),
    linkedCompleted() {
      return this.item.linked_requests.filter((i) => i.status === "COMPLETED").length
    },
    priority() {
      let priority = ""
      switch (this.item.priority) {
        case 1:
          priority = "Minor"
          break
        case 2:
          priority = "Medium"
          break
        case 3:
          priority = "Major"
          break
      }
      return priority
    }
  },
  props: {
    item: Object,
    type: {
      type: String,
      default: ''
    }
  },
}
</script>
<style lang="sass" rel="stylesheet/sass">
.component.component-backoffice-note
  .description
    white-space: pre
</style>



// WEBPACK FOOTER //
// InterventionRequest.vue?47507eb3